import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { pageKeyForPath } from '../constants/pageAccess';
import { MandatoryTwoFactorLock } from './auth/MandatoryTwoFactorLock';

interface ProtectedRouteProps {
    allowedRoles: string[];
}

const ProtectedRoute = ({ allowedRoles }: ProtectedRouteProps) => {
    const { user, userRole, isAuthenticated, hasPageAccess } = useAuth();
    const location = useLocation();

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    // Mandatory 2FA Lock Enforcement: If user has not enabled 2FA AND is not explicitly exempted by instructor/admin
    if (user && !user.two_factor_enabled && !user.two_factor_exempt) {
        return <MandatoryTwoFactorLock />;
    }

    const dashboardForRole = () => {
        switch (userRole) {
            case 'student': return '/student-dashboard';
            case 'instructor': return '/instructor-dashboard';
            case 'admin': return '/admin-dashboard';
            default: return '/login';
        }
    };

    if (userRole && !allowedRoles.includes(userRole)) {
        return <Navigate to={dashboardForRole()} replace />;
    }

    const pageKey = pageKeyForPath(location.pathname);
    if (!hasPageAccess(pageKey)) {
        return <Navigate to={dashboardForRole()} replace />;
    }

    return <Outlet />;
};

export default ProtectedRoute;
